// External Dependencies:
import React from 'react'

// Internal Dependencies:
import { loopArray } from 'utilities/arrays'
import { loop, get } from 'utilities/objects'

class DataTable extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			selectedRows: {}
		}
	}

	handleClickRow = ( e ) => {
		const id = e.currentTarget.getAttribute( 'data-id' )
		const { selectedRows } = this.state

		this.setState( {
			selectedRows: {
				...selectedRows,
				[ id ]: ! selectedRows[ id ]
			}
		} )
	}

	renderHeaderColumn = ( key, item ) => {
		const flex = item.flex ? item.flex : 1
		const align = item.align ? item.align : 'left'
		const style = {
			flex: flex,
			textAlign: align
		}
		let onClick
		let className = '-cell'

		return (
			<div className={ className } key={ key } style={ style } onClick={ onClick } data-id={ item.data_key }>
				<p>{ item.title }</p>
			</div>
		)
	}

	renderRow = ( key, item ) => {
		const { columns, renderSelectedRowInner } = this.props
		const { selectedRows } = this.state

		let className = '-row'

		if ( selectedRows[ key ] ) {
			className += ' is-selected'
		}

		let markup = [
			<div className={ className } key={ key } onClick={ this.handleClickRow } data-id={ key }>
				{ loopArray( columns, this.renderRowCell, item ) }
			</div>
		]

		if ( selectedRows[ key ] ) {
			markup.push(
				<div className="-row" key={ `${key}-selected-inner` }>
					{ renderSelectedRowInner( key, item ) }
				</div>
			)
		}

		return markup
	}

	renderRowCell = ( key, columnData, item ) => {
		const flex = columnData.flex ? columnData.flex : 1
		const align = columnData.align ? columnData.align : 'left'
		const style = {
			flex: flex,
			textAlign: align
		}
		let rowData = item[ columnData.data_key ]

		if ( columnData.data_key_2 ) {
			rowData += ` ${item[ columnData.data_key_2 ]}`
		}

		let markup, innerMarkup, text
		let dataType = columnData.data_type

		if ( 'text' == dataType ) {
			markup = <p>{ rowData }</p>
		}

		return (
			<div className="-cell" key={ key } style={ style }>
				{ markup }
			</div>
		)
	}

	render() {
		const { data, columns } = this.props

		return (
			<div className="data-table">
				<div className="-inner">
					<div className="-header">
						{ loopArray( columns, this.renderHeaderColumn ) }
					</div>

					<div className="-body">
						{ loop( data, this.renderRow ) }
					</div>
				</div>
			</div>
		)
	}
}

export default DataTable
